<template>
<div>
    
	<div class="container_full" >
		<div class="container margin_60_35">			
			<div class="row">
				<div class="col-lg-6">
					<div >
						<img src="@/assets/img/logo.png"/>
					</div>
					<div class="p-3">
						<h2>Propuesta</h2>
						<div class="box_feat_2">
							<h3>La Primera Plataforma de Receta Digital del País.</h3>
								<ul>
								<li> Alineada con las normas del Gobierno (MSP, AGESIC, SaludUy).</li>
								<li> Desarrollada de acuerdo los mayores estándares tecnológicos internacionales.</li>
								<li> 100% de la oferta de fármacos, asegurada por el DNMA (Diccionario Nacional de Medicamentos).</li>
								<li> Seguridad total en el manejo de los datos.</li>
								<li> Más de 500 farmacias en todo el País.</li>
								<li> Mayor adhesión al tratamiento por parte del Paciente.</li>
								<li> Control detallado del historial de Prescripciones.</li>
							</ul>
							<p class="">Registrate SIN COSTO y accedé a todos los BENEFICIOS para vos y tus Pacientes.</p>
						</div>
					</div>			
				</div>

				
				<div class="col-lg-5 ml-auto">
					<div class="box_form">
						
						<FormulateForm
							v-if="!loading"
							ref="form"
							v-model="form"
							@submit="save" 
							>
							
							<FormulateInput
								label="CJP"
								name="cjp"
								placeholder="CJP"
								validation-name="CJP"
								validation="required"
							/>
							<FormulateInput
								label="Especialidad"
								validation-name="Especialidad"
								name="especiality"
								:options="especialities"
								type="selectSearch"
								option-value="id"
								option-text="name"
								placeholder="Seleccione su especialidad"
								validation="required"
								:disabled="loadingCountries"
							/>	

							<FormulateInput
								label="Nombre"
								name="name"
								placeholder="Nombre"
								validation-name="Nombre"
								validation="required"
							/>
							
							<FormulateInput
								label="Apellido"
								name="lastname"
								placeholder="Apellido"
								validation-name="Apellido"
								validation="required"
							/>

							<FormulateInput
								type="identification"
								label="Documento de identidad"
								name="document"
								validation-name="Documento de identidad"
								validation="optional|^documentID"
							/>


							<FormulateInput
								class="mt-2"
								type="date"
								name="birthdate"
								validation-name="La fecha de nacimiento"
								label="Fecha de nacimiento"
								:splitted="true"
								:validation="`required`"
							/>



							<FormulateInput
								label="Email"
								type="email"
								name="email"
								placeholder="Email"
								validation-name="Email"
								validation="required"
							/>
							<FormulateInput
								label="Confirmar email"
								type="email"
								name="email_confirm"
								placeholder="Confirmar email"
								validation-name="Confirmar email"
								validation="required|confirm"
							/>

							<FormulateInput
								label="Contraseña"
								type="password"
								name="password"
								:showMeter="true"
								placeholder="Contraseña"
								validation-name="Contraseña"
								validation="required"
							/>

							<FormulateInput
								name="password_confirm"
								type="password"
								label="Confirmar contraseña"
								placeholder="Confirmar contraseña"
								validation="required|confirm"
								validation-name="Confirmar contraseña"
							/>

							<FormulateInput
								label="Teléfono"
								type="phone"
								name="phone"
								validation-name="Teléfono"
								validation="optional|^phone"
							/>

							
							<FormulateInput
								name="terms"
								type="checkbox"
								label="Aceptar términos y condiciones"
								validation="required"
								validation-name="Términos y condiciones"
							/>

							
							<div class="d-flex justify-content-between mt-4">
								<FormulateInput type="button" data-ghost @click="$router.go(-1)" >Cancelar</FormulateInput>
								<FormulateInput type="button" disabled v-if="saving">Guardando <span class="loader" /></FormulateInput>
								<FormulateInput type="submit" label="Registrarme" v-else />
							</div>

							<div class="text-center mt-4">	
								Al crear una cuenta, acepto los <a href="https://recetalia.com/terms" target="_blank">Términos y condiciones</a> y las <a href="https://recetalia.com/privacy" target="_blank">Políticas de privacidad</a> de Recetalia.
							</div>

						</FormulateForm>

					</div>
					<p class="text-center link_bright">
                        ¿Ya estas registrado? <router-link tag="a" to="/login"><strong>Ingresar!</strong></router-link>
                    </p>
					<!-- /box_form -->
				</div>
				<!-- /col -->
			</div>
			<!-- /row -->
		</div>
			
    </div>
    
</div>
</template>

<script>
import gql from 'graphql-tag'
import { onLogin } from '../../vue-apollo'
import { mapMutations } from 'vuex'


import Password from 'vue-password-strength-meter'
export default {
	name: 'Register',
	metaInfo: {
		title: 'Registrarme',
	},
    components: {
		Password
    },
    data() {
        return {
			form:{
				cjp: null,
				name: null,
				lastname: null,
				document:{
					type: 'UY', number: null
				},
				birthdate: null,
				email: null,
				emailConfirm: null,
				phone: null,
				password: null,
				passwordConfirm: null,
				especiality: null,
			},
			termsAndConditions:false,
			showPassword:false,
			saving:false,
			loading:false,
			passwordStrength:0,
			especialities:[]
        }
	},
	beforeMount(){
        this.logout();
		this.fetchData()
    },
	methods:{
		...mapMutations(['authSuccess','logout']),
        passwordScore (score) {
            this.passwordStrength = score;
        },

		save(){
			
			if(!this.saving){
				this.saving = true
				let dataInput = {
					cjp: this.form.cjp,
					name: this.form.name,
					lastname: this.form.lastname,
					email: this.form.email,
					document: this.form.document,
					birthdate: this.$moment(this.form.birthdate).format('YYYY-MM-DD'),
					phone: this.form.phone,
					password: this.form.password,
					especiality: this.form.especiality,
				}
				
				this.$apollo.mutate({
					mutation: gql`mutation ( $data:MedicRegisterInput! ){
						medicRegister( data: $data) {
							token
							medic{
								id
								name
								lastname
								email
							}
						}
					}`,
					variables: {
						data: dataInput
					}
				})
				.then(({data}) => {
					this.$toast.success('Registro satisfactorio')
					let access_token = data.medicRegister.token
                    let logged_medic = data.medicRegister.medic
                    onLogin(this.$apollo.provider.defaultClient, access_token, logged_medic).then(() => { 
						console.log('asds')
                        this.authSuccess({token:access_token, loggedMedic: logged_medic})
						this.loading = false
                        this.$router.push('/')
                    });
				})
				.catch( (error) => {
					this.parseGQLErrors(error)
					this.saving = false
				})
			}
		},

		fetchData(){
			return this.$apollo.query({
				query: gql`query {
					medicEspecialities{
						id
						name
					}
				}`,
				fetchPolicy: 'network-only',
			})
			.then(({data}) => {
				this.especialities = data.medicEspecialities
				
			})
			.catch((err)=>{
				console.log(err)
			})

		},

		
    },
}
</script>

<style scoped>
.container_full{
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto !important;
    padding-top: 5% !important;
    max-width: 95% !important;
}
#hero_register {
  
  color: #5a5d5c;
}
#hero_register h1 {
  color: #5a5d5c;
}
@media (max-width: 767px) {
  #hero_register h1 {
    /* For less than 767px */
    font-size: 32px;
    font-size: 2rem;
  }
}


#register {
    margin: 60px auto;
    color: #fff;
}

#register h1 {
    font-size: 28px;
    font-size: 1.75rem;
    text-align: center;
    margin: 0 0 30px 0;
    color: #fff;
}

#login {
    width: 400px;
    margin: 60px auto;
    color: #fff;
}

@media (max-width: 767px) {
    #login {
        /* For less than 767px */
        width: 100%;
        margin: 30px 0;
    }
}

#login h1 {
    font-size: 28px;
    font-size: 1.75rem;
    text-align: center;
    margin: 0 0 30px 0;
    color: #fff;
}

@media (max-width: 767px) {
    #login h1 {
        /* For less than 767px */
        font-size: 21px;
        font-size: 1.3125rem;
    }
}

.divider {
    text-align: center;
    height: 1px;
    margin: 30px 0;
    background-color: #e1e8ed;
}

.divider span {
    position: relative;
    top: -20px;
    background-color: #fff;
    display: inline-block;
    padding: 10px;
    font-style: italic;
}


#login-2 {
    width: 650px;
    margin: 60px auto;
    color: #fff;
}

#login-2 .box_form {
    padding: 30px 0 0 0;
}

.box_form .form-group{
	margin-bottom: 1rem;
}

@media (max-width: 767px) {
    #login-2 .box_form {
        /* For less than 767px */
        padding: 20px 20px 0 20px;
    }
}

#login-2 .forgot {
    display: inline-block;
    margin-top: 5px;
}

@media (max-width: 767px) {
    #login-2 {
        /* For less than 767px */
        width: 100%;
        margin: 0;
    }
}

#login-2 h1 {
    font-size: 28px;
    font-size: 1.75rem;
    text-align: center;
    margin: 0 0 30px 0;
    color: #fff;
}

.box_login {
    width: 50%;
    float: left;
    border-right: 1px solid #e1e8ed;
    padding: 15px 25px;
}

@media (max-width: 767px) {
    .box_login {
        /* For less than 767px */
        width: 100%;
        border-right: 0;
        padding: 0;
    }
}

.box_login.last {
    border-right: 0;
}

a.social_bt {
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    border-radius: 3px;
    text-align: center;
    color: #fff;
    min-width: 200px;
    margin-bottom: 15px;
    display: block;
    padding: 12px;
    line-height: 1;
    position: relative;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
}

a.social_bt:hover {
    -webkit-filter: brightness(115%);
    filter: brightness(115%);
}

a.social_bt.facebook:before,
a.social_bt.google:before,
a.social_bt.linkedin:before {
    font-family: 'ElegantIcons';
    position: absolute;
    left: 12px;
    top: 10px;
    font-size: 1rem;
    color: #fff;
}

a.social_bt.facebook {
    background-color: #3B5998;
}

a.social_bt.facebook:before {
    content: "\e093";
}

a.social_bt.google {
    background-color: #DC4E41;
}

a.social_bt.google:before {
    content: "\e096";
    top: 12px;
}

a.social_bt.linkedin {
    background-color: #0077B5;
}

a.social_bt.linkedin:before {
    content: "\e09d";
}


.box_feat_2 {
  position: relative;
}
.box_feat_2 h3 {
  font-size: 18px;
  font-size: 1.125rem;
  color: #616161;
}
.box_feat_2 i {
  font-size: 46px;
  font-size: 2.875rem;
  margin-bottom: 10px;
  color: #74d1c6;
  position: absolute;
  left: 0;
  top: 0;
}


.btn_1{
	display: table;
	margin: auto;
}


.link_bright a {
    color: #12bcec;
}


</style>
